import {
  Text,
  IconClock,
  IconSignature,
  GreyGrey70,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

import { NodeTimeline, QuotePreviewCard } from 'Automations/components'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useQuoteData } from '../../hooks/useQuoteData'
import { RegeneratePdfAction } from '../../components/RegeneratePdfAction'

export const QuotePdfGenerationTimeoutPreview = (props: { taskId: string }) => {
  const { manualTask } = useManualTask({ taskId: props.taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { quote, customer } = useQuoteData(input?.quoteId)

  const hasQuoteData = quote && customer

  return (
    <>
      <NodeTimeline.Item icon={<IconSignature />} showStem>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label="Quote created"
            timestamp={quote?.createdAt}
          />
        </NodeTimeline.Title>

        {hasQuoteData && (
          <QuotePreviewCard quote={quote} customer={customer} startCollapsed />
        )}
      </NodeTimeline.Item>

      <NodeTimeline.Item icon={<IconClock />} showStem={false} highlightIcon>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                PDF generation timed out
              </Text>
            }
            timestamp={manualTask?.createdAt}
          />
        </NodeTimeline.Title>

        <Text {...Primary13Regular} color={GreyGrey70} marginBottom="16px">
          Generating the PDF for this quote took too long and was cancelled. You
          can retry now.
        </Text>

        {hasQuoteData && input && (
          <QuotePreviewCard
            quote={quote}
            customer={customer}
            action={
              <RegeneratePdfAction
                quoteId={input.quoteId}
                quoteVariantId={input.quoteVariantId}
              />
            }
          />
        )}
      </NodeTimeline.Item>
    </>
  )
}
